module.exports = __webpack_public_path__ + "img/3.f942e5aa.jpeg";